// T-236: o balão vermelho diz o que aconteceu.
//
// Antes, uma mensagem que falhava ficava vermelha e MUDA. O texto do erro só aparecia quando
// vinha do servidor (`external_error`); a falha do navegador ia para `meta.error`, que a tela
// nem lê. Quem atende via um balão vermelho sem uma palavra, e quem sustenta não tinha o que
// investigar.
//
// Custou dias. O defeito dos anexos (T-235) ficou no ar porque a requisição morria no firewall
// de borda ANTES de chegar ao servidor: não havia 4xx em log nenhum, e o único sinal na tela era
// a cor. Duas pessoas relataram "não funciona" sem conseguir dizer mais do que isso.
//
// Este arquivo só CLASSIFICA a falha; quem escreve a frase é a tela, porque é lá que existe
// tradução. Guardar a classificação, e não o texto pronto, também evita congelar no banco uma
// frase em português que um dia mude.

export const O_QUE = {
  MENSAGEM: 'MENSAGEM',
  ANEXO: 'ANEXO',
  AMBOS: 'AMBOS',
};

export const POR_QUE = {
  SEM_RESPOSTA: 'SEM_RESPOSTA',
  SEM_RESPOSTA_COM_ANEXO: 'SEM_RESPOSTA_COM_ANEXO',
  GRANDE_DEMAIS: 'GRANDE_DEMAIS',
  RECUSADO: 'RECUSADO',
  SESSAO: 'SESSAO',
  SERVIDOR: 'SERVIDOR',
};

const oQueFalhou = mensagem => {
  const temAnexo = Boolean(mensagem?.files?.length);
  const temTexto = Boolean(String(mensagem?.message ?? '').trim());

  if (temAnexo && temTexto) return O_QUE.AMBOS;
  if (temAnexo) return O_QUE.ANEXO;
  return O_QUE.MENSAGEM;
};

const porQueFalhou = (error, temAnexo) => {
  const resposta = error?.response;

  // Sem resposta: a requisição não chegou a ser respondida. Rede de quem enviou, ou algo no
  // caminho (firewall de borda, proxy) recusando antes do servidor. Foi exatamente o T-235.
  // Arquivo grande é a causa mais comum de longe, então a dica vai junto em vez de deixar a
  // pessoa adivinhar.
  if (!resposta) {
    return temAnexo ? POR_QUE.SEM_RESPOSTA_COM_ANEXO : POR_QUE.SEM_RESPOSTA;
  }
  if (resposta.status === 413) return POR_QUE.GRANDE_DEMAIS;
  if (resposta.status === 403) return POR_QUE.RECUSADO;
  if (resposta.status === 401) return POR_QUE.SESSAO;

  return POR_QUE.SERVIDOR;
};

/**
 * Classifica a falha de envio para a tela poder explicá-la.
 * Devolve `{ oQue, porQue, status, detalhe }`. `detalhe` é a explicação do PRÓPRIO servidor
 * quando ela existe: é melhor que qualquer texto nosso, porque sabe do caso concreto.
 */
export const classificarFalha = (error, mensagem) => {
  const temAnexo = Boolean(mensagem?.files?.length);
  const resposta = error?.response;

  return {
    oQue: oQueFalhou(mensagem),
    porQue: porQueFalhou(error, temAnexo),
    status: resposta?.status ?? null,
    detalhe: resposta?.data?.error || resposta?.data?.message || null,
  };
};
